import { useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { clsx } from 'clsx';
import { useApprovalBadgeStore } from '@shared/stores/approvalBadgeStore';
import { useApprovalBadgePoller } from '@shared/hooks/useApprovalBadgePoller';
import { useBitrix24 } from '@shared/hooks/useBitrix24';

const navItems = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/products', label: 'Products' },
  { to: '/tasks', label: 'Tasks' },
  { to: '/approvals', label: 'Approvals', badge: true },
  { to: '/actions', label: 'Actions' },
  { to: '/orders', label: 'Orders' },
  { to: '/settings', label: 'Settings' },
];

export function Layout() {
  useApprovalBadgePoller();
  const badgeCount = useApprovalBadgeStore((s) => s.count);
  const { fitWindow } = useBitrix24();
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => fitWindow(), 100);
    return () => clearTimeout(timer);
  }, [location.pathname, fitWindow]);

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-200">
        <div className="px-4 py-3 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-tailorcast-primary rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">SC</span>
            </div>
            <h1 className="text-lg font-semibold text-gray-900">AI Store Copilot</h1>
          </div>

          <nav className="flex items-center gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  clsx(
                    'relative px-3 py-2 rounded-lg text-sm font-medium transition-colors',
                    isActive
                      ? 'bg-tailorcast-primary/10 text-tailorcast-primary'
                      : 'text-gray-600 hover:bg-gray-100'
                  )
                }
              >
                {item.label}
                {item.badge && badgeCount > 0 && (
                  <span className="absolute -top-1 -right-1 inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-red-500 rounded-full">
                    {badgeCount > 9 ? '9+' : badgeCount}
                  </span>
                )}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="p-4">
        <Outlet />
      </main>
    </div>
  );
}
